import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { Button } from '@/components/ui/button';
import { getSpanish } from '@/content/es';
import { renderSpanish, spanishUrl, isLive } from '@/lib/spanishFormat';
import { CALENDLY_URL } from '@/lib/site';
import NotFound from './NotFound';

/**
 * /es and /es/* pages. Content is markdown in src/content/es, rendered by the
 * same function the prerenderer uses. Drafts carry noindex until a Spanish
 * speaker has reviewed them (status: reviewed).
 */
const SpanishPage = () => {
  const { pathname } = useLocation();
  const page = getSpanish(pathname.replace(/\/$/, '') || '/es');

  useEffect(() => {
    if (!page) return;
    document.documentElement.lang = 'es';
    return () => {
      document.documentElement.lang = 'en';
    };
  }, [page]);

  if (!page) return <NotFound />;

  return (
    <div lang="es" className="min-h-screen pt-16 bg-gradient-to-b from-white to-slate-100 dark:from-slate-900 dark:to-slate-950">
      <Helmet>
        <title>{page.metaTitle}</title>
        <meta name="description" content={page.description} />
        <link rel="canonical" href={spanishUrl(page)} />
        {!isLive(page) && <meta name="robots" content="noindex" />}
      </Helmet>
      <div className="container-custom py-12 max-w-3xl mx-auto">
        <article
          className="prose prose-lg prose-slate dark:prose-invert max-w-none prose-a:text-primary"
          dangerouslySetInnerHTML={{ __html: renderSpanish(page) }}
        />
        <div className="mt-12 rounded-2xl border border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900 p-8 text-center">
          <h2 className="text-2xl font-bold">¿Hablamos?</h2>
          <p className="mt-2 text-slate-600 dark:text-slate-300">
            Reserve una llamada gratuita de 30 minutos. Podemos hablar en español.
          </p>
          <Button asChild size="lg" className="mt-6 rounded-full">
            <a href={CALENDLY_URL} target="_blank" rel="noopener noreferrer">Reservar una llamada</a>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default SpanishPage;
